import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { ContatoAssistencialService} from './contato-assistencial.service';
import { BaseClientService } from './base-client.service';
import { ConfigService } from './config.service';
import { UfService } from './uf.service';
import { MunicipioService } from './municipio.service';
import { TerminologiaService } from './terminologia.service';
import { PaisService } from './pais.service';

@NgModule({
  imports: [
  ],
  providers: [
    BaseClientService,
    AuthService,
    ContatoAssistencialService,
    UfService,
    MunicipioService,
    ConfigService,
    TerminologiaService,
    PaisService
  ],
})
export class ServicesModule {}
